/**
 * Format a raw phone string for nicer display in the contact detail panel.
 *
 * We only reformat North American Numbering Plan (NANP, +1) numbers — the one
 * case we can confidently pretty-print without pulling in a full phone library.
 * Anything else (other country codes, extensions, partial input) is returned
 * unchanged so we never mangle a number we don't fully understand.
 *
 *   "+18594924491" -> "+1 (859) 492-4491"
 *   "8594924491"   -> "(859) 492-4491"
 *   "+447911123456" -> "+447911123456" (left as-is)
 */
export function formatPhoneDisplay(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.length === 0) return trimmed;

  const digits = trimmed.replace(/\D/g, '');

  // 10-digit NANP without country code -> (859) 492-4491
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // 11-digit NANP starting with 1 -> +1 (859) 492-4491
  if (digits.length === 11 && digits.startsWith('1')) {
    const local = digits.slice(1);
    return `+1 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  }

  // International / unrecognized — leave exactly as stored.
  return trimmed;
}
